import issuesSlice from './slice';

export const {
  fetchIssues,
  fetchIssuesError,
  fetchIssuesSuccess,
  fetchIssuesSearch,
  putIssueStatus,
  putIssueStatusSuccess,
  fetchIssuesDashboardError,
  fetchIssuesDashboard,
  fetchIssuesDashboardSuccess,
  setDefaultIntialIssues,
  fetchIssuesSearchSuccess,
  fetchIssuesSearchError,
  fetchUserReportedIssuesSearch,
  fetchUserReportedIssuesSearchSuccess,
  fetchUserReportedIssuesSearchError
} = issuesSlice.actions;
export default issuesSlice.reducer;

export * from './types';
